document.addEventListener('DOMContentLoaded',()=>{const form=document.querySelector('#pd-localization');if(form){form.querySelector('[data-pd-return]').value=location.pathname+location.search;form.querySelector('select').addEventListener('change',()=>{try{localStorage.setItem('pd-language',form.querySelector('select').value);}catch{}form.requestSubmit();});const supported=[...form.querySelector('select').options].map(o=>o.value);const automatic=location.pathname==='/';let chosen;try{chosen=localStorage.getItem('pd-language');}catch{}if(!chosen){chosen=(navigator.languages||[navigator.language]).map(l=>l.split('-')[0]).find(l=>supported.includes(l));}if(automatic&&!new URLSearchParams(location.search).has('preview_theme_id')&&chosen&&supported.includes(chosen)&&chosen!==document.documentElement.lang){form.querySelector('select').value=chosen;form.requestSubmit();}}document.querySelectorAll('[data-pd-archive]').forEach(b=>b.addEventListener('click',()=>document.getElementById(b.dataset.pdArchive).showModal()));document.querySelectorAll('[data-pd-archive-close]').forEach(b=>b.addEventListener('click',()=>b.closest('dialog').close()));});
// Reopen Shopify's native privacy preferences without changing consent.
(function () {
  document.addEventListener('click', function (event) {
    const link = event.target.closest && event.target.closest('a[href*="#shopifyReshowConsentBanner"]');
    if (!link) return;
    const target = new URL(link.href, location.href);
    if (target.origin !== location.origin || target.pathname !== location.pathname) return;
    event.preventDefault();
    let attempts = 0;
    function openNativePreferences() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
        return;
      }
      if (++attempts < 20) {
        setTimeout(openNativePreferences, 250);
        return;
      }
      // Preserve the native anchor fallback when the existing banner is unavailable.
      location.hash = 'shopifyReshowConsentBanner';
    }
    openNativePreferences();
  });
})();
